import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CountUp from 'react-countup';
import $ from "jquery";
import { SettingsRemoteRounded } from '@mui/icons-material';
import CongPopupAnimation from "./CongPopupAnimation";
import { useDispatch, useSelector } from 'react-redux';
import { setCongratClassName } from '../../redux/assignCourse/actions';
function CongratulationsPopup(props) {

  const { title, lpPoints, fromPage,setIsAnimCompleted,name, via_lp, lp_id, isMobile,isSurvey } = props; // fromPage ==> 0 = learningpoint, 1 = badge, 2 = certificate
  
  const dispatch = useDispatch();

  const congratClassName = useSelector(state => state.assignCourse.congrat_class_name)

  const [timeOutAnimation, setTimeOutAnimation] = useState(true)
  const [counterValue, setCountValue] = useState(null)
  const [timerValue, setTimerValue] = useState(true)
  const [timeZoom, setTimeZoom] = useState(true)
  const [timerZoom, setTimerZoom] = useState(true)


  useEffect(() => {
    // flyToProfileSec()
    setTimeout(() => {
      setTimeOutAnimation(false)
    }, 5500)
    setTimeout(() => {
      setTimerValue(false)
    }, 3200)
    setTimeout(() => {
      setTimeout(() => {
        dispatch(setCongratClassName('step'))
        setTimeout(() => {
          dispatch(setCongratClassName('step1')) //setting class for blinking profile pic
          // setIsAnimCompleted(true)
        }, 3000)
      }, 2000)
      setTimerZoom(false)   // setting class on this flag, for fly points
    }, 3700)
  }, [])

  useEffect(() => {
    if (congratClassName === 'step1') {
      setTimeout(() => {
        setIsAnimCompleted(true)
        console.log('Animation is completed')
      }, 5000)
    }
  }, [congratClassName])

  return (
    <>
      {timeOutAnimation ? <div
        className="modal congrtsmodal show"
        style={{ display: 'block' }}
      >
        <Modal.Dialog centered>

          <Modal.Body className="congratulationmodal">
            <h4>Congratulations</h4>
            <div className="congrtsbox">
              <p>You have successfully completed the <strong dangerouslySetInnerHTML={{
                __html: title,
              }}></strong> {name}.</p>
              <p>You have just earned yourself</p>
            </div>
            <div className="d-flex gap-2 justify-content-center centerboxcongrats">
              <div className="counmainbx">
                <div className={(timerZoom === true) ? "countbox" : "zoom"}>
                  <div className="d-flex gap-4 justify-content-between">
                   {isSurvey ?"": <div className="points-box-earned">
                      <div className="countno">+<CountUp duration={3} start={0} end={lpPoints} delay={0}>
                        {({ countUpRef }) => (
                          <strong className="counteranime">
                            <span ref={countUpRef} />
                          </strong>
                        )}
                      </CountUp></div>
                      <div className="lerpoints">Learning <br />Points</div>
                    </div>}

                    {fromPage === 1 ? <div className="earned_badge">
                      <img src="/images/badge-1.jpg" className="img-fluid" style={{ width: '64px' }} />
                      <div className="lerpoints">{title} Badge</div>
                    </div>
                      :
                      fromPage === 2 ? <div className="earned_badge">
                        <img src="/images/my_certificate.png" className="img-fluid" style={{ width: '64px' }} />
                        <div className="lerpoints">{title} Certificate</div>
                      </div> : ""
                    }
                  </div>
                </div>

              </div>
            </div>
          </Modal.Body>
        </Modal.Dialog>
      </div> : ""}
      {false && (timerValue) ? <CongPopupAnimation /> : ""}
    </>
  );
}

export default CongratulationsPopup;

